import { useEffect, useContext } from "react"
import { LoginForm } from "source/login/LoginForm"
import { ServerRenderedProps } from "source/shared/contexts/ServerRenderedProps"
import { HardRefresh } from "source/shared/routingUtils"
import { resetCache as resetNavitarCache } from "@planningcenter/cc-nav"
import { resetCache as resetWebBootCache } from "source/publishing/WebBoot"
import { useNavigate } from "react-router-dom"
import { useFlipperFeatureEnabled } from "source/shared/flipperFeatures"

export function Login() {
  const navigate = useNavigate()
  // TODO: When this feature flag is removed we also need to make sure
  // LoginForm's onSuccess prop type is updated to not allow null.
  const refreshlessLoginEnabled = useFlipperFeatureEnabled(
    "ROLLOUT_refreshless_login",
  )

  function onSuccess() {
    const params = new URLSearchParams(window.location.search)
    const returnUrl = params.get("return")

    const newLocation = returnUrl ? new URL(returnUrl).pathname : "/home"
    navigate(newLocation)
  }

  const { login } = useContext(ServerRenderedProps)
  return (
    <LoginForm
      emailOnly={login.email_only}
      onSuccess={refreshlessLoginEnabled ? onSuccess : null}
    />
  )
}

export function Logout() {
  useEffect(() => {
    resetNavitarCache()
    resetWebBootCache()
  }, [])
  return <HardRefresh />
}
